import './App.less';
import { Browser } from './components/Browser';
import ReactGA from 'react-ga';

function App() {
  
  const TRACKING_ID = "UA-113017641-27";
  ReactGA.initialize(TRACKING_ID,{ debug: true });
  ReactGA.pageview("/");

  return (
    <div className="App">
      <Browser />
    </div>
  );
}

export default App;